export var PAY_MODE = {
    PAYMENT_METHOD: 'paymentMethod',
    ASSIGNED_PAYMENT: 'assignedPayment'
};
